const filter = (value, type: string): string => {
  if (isNaN(value)) {
    return ''
  }

  const options = {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 2
  }

  switch (type) {
    case 'integer':
      options.maximumFractionDigits = 0
  }

  return new Intl.NumberFormat('pt-BR', options).format(value)
}

export default filter
